import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { reactivateReservation } from 'restaurantAdmin/reservations/apiHelpers';
import { errorToast, successToast } from '@components/toasts/Toasts';
import { ApiError } from '@shared/api/errors';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useReactivateReservion = (
  reservationId: string,
  onSuccess?: () => void,
) => {
  const { id: restaurantId } = useRestaurant();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () =>
      reactivateReservation({
        restaurantId,
        reservationId,
      }),
    onError: (error) => {
      if (error instanceof ApiError) {
        errorToast({
          message: `Failed to reactivate reservation: ${error.message}`,
        });
      } else {
        errorToast({
          message: 'Failed to reactivate reservation. Please try again.',
        });
      }
    },
    onSuccess: () => {
      successToast({ message: 'Reservation reactivated successfully.' });
      onSuccess?.();
      queryClient.invalidateQueries({
        queryKey: [
          'restaurants',
          restaurantId,
          'occupants',
          'reservation',
          reservationId,
        ],
      });
    },
  });
};
